const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  saving: false,
  saved: false,
  error: null,
  features: null,
  amenities: null,
  details: null,
  pricing: null,
  fulfilling_moments: null,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'LISTING_RESET':
      return initialState

    case 'LISTING_FETCH_PENDING':
      return {
        ...state,
        fetching: true,
      }

    case 'LISTING_FETCH_REJECTED':
      return {
        ...state,
        fetching: false,
        error: true,
      }

    case 'LISTING_FETCH_FULFILLED':
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data.listing.data,
        features: action.payload.data.listing.features,
        amenities: action.payload.data.listing.amenities,
        details: action.payload.data.listing.details,
        pricing: action.payload.data.listing.pricing,
        fulfilling_moments: action.payload.data.listing.fulfilling_moments,
      }

    case 'BUCKET_LIST_ADD_FULFILLED':
      return {
        ...state,
        data: {
          ...state.data,
          added_to_bucket_list: true,
        },
      }

    case 'BUCKET_LIST_REMOVE_FULFILLED':
      return {
        ...state,
        data: {
          ...state.data,
          added_to_bucket_list: false,
        },
      }

    default:
      return state
  }
}
